query getCrmCompanyConfig($companyId: ID!) {
  config: getCrmCompanyConfig(companyId: $companyId) {
    companyId
    crmProvider
    syncModus
    isActive
    hasBeenActivated
    isUsedByUser
  }
}
